import Base from './components/cells/Base';
import Avatar from './components/cells/Avatar';
import { isSameAvatarCellContent } from './isSameAvatarCellContent';

export default function AvatarCell() {}

AvatarCell.prototype.init = function (params) {
    this.params = params;
    this.eGui = Base(Avatar(params), params);
    return;
};

AvatarCell.prototype.refresh = function (params) {
    const rowChanged = this.params?.node?.id !== params?.node?.id;
    if (!rowChanged && isSameAvatarCellContent(this.params, params)) {
        this.params = params;
        return true;
    }

    this.params = params;
    this.eGui = Base(Avatar(params), params);
    return true;
};

AvatarCell.prototype.getGui = function () {
    return this.eGui;
};
